import { render } from 'react-dom';
import App from './App';
import './i18n';
import './index.css'

const rootElement = document.getElementById('root');

render(<App />, rootElement);